module.exports = __webpack_public_path__ + "static/media/search.b06a89ac.svg";